import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";

const COLORSparqueExt = ["#eb7c30", '#edb691'];
const COLORSparqueMO = ["#a3a3a3", '#dbd9d9'];
const COLORSparqueMT = ["#ffa500", '#f9d28a'];

const parqueExt = [
  {
    name: 'Ocupado',
    value: 300 //resultByParks[0]
  },
  {
      name: 'Livre',
      value: 700 //resultByParks[1]
  }
];

const parqueMO = [
  {
    name: 'Ocupado',
    value: 15 //resultByParks[0]
  },
  {
      name: 'Livre',
      value: 85 //resultByParks[1]
  }
];

const parqueMT = [
  {
      name: 'Ocupado',
      value: 60 //resultByParks[0]
  },
  {
      name: 'Livre',
      value: 40 //resultByParks[1]
  }
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, value }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN) - 1;

  return (
    <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize='x-small'>
      {value}
    </text>
  );
};

export const CostumPieChart2 = (props) => {
  const renderLegend = (props2) => {
    return (
      <p style={{margin: 0, textAlign: 'center', color: props.colors[0]}}>{props.name}</p>
    );
  };

  return (
    <>
      <ResponsiveContainer width="40%" height={90}>
        <PieChart style={{textAlign: 'start'}}>
          <Pie
            data={props.data.result}
            cx="50%"
            cy="44%"
            innerRadius={10}
            outerRadius={30}
            fill="#8884d8"
            dataKey="value"
            labelLine={false}
            label={renderCustomizedLabel}
            startAngle={90}
            endAngle={-270}
          >
            {props.data.result.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={props.colors[index % props.colors.length]}
              />
            ))}
          </Pie>
          <Legend
            verticalAlign="bottom"
            iconType="circle"
            iconSize={9}
            align="center"
            // width='145px'
            wrapperStyle={{ left: 0 }}
            content={renderLegend}/>
        </PieChart>
      </ResponsiveContainer>
    </>
  );
};


